<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="sideOverShow = false"
		></div>
		<PercentSlideOver
			@close="sideOverShow = false"
			@submit="submit"
			:sideOverShow="sideOverShow"
			:endPercent="autoFillData?.end_percent"
			:startPercent="autoFillData?.start_percent"
			:nextPlan="autoFillData?.next_plan_for_unlearned_goal"
		/>
	</div>
	<div class="h-full w-full">
		<div
			class="
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
			"
		>
			<div
				class="
					__section__header
					font-semibold
					text-neutral-600
					p-6
					border-b
				"
			>
				<div class="text-neutral-600">Báo cáo bắt buộc</div>

				<div
					class="text-neutral-500 font-normal leading-5 text-sm mt-2"
					style="max-width: 700px"
				>
					Trị liệu viên bắt buộc phải hoàn thành các loại báo cáo được
					bật bên dưới.
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								w-56
								uppercase
								text-neutral-400 text-xs
								font-semibold
							"
						>
							Báo cáo tuần
						</div>
						<SwitchButton v-model:value="enable_weekly_report" />
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				mt-10
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
			"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">
					Nhận xét và ghi chú trong báo cáo cá nhân
				</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					Ở chế độ bật, trị liệu viên bắt buộc phải điền nhận xét buổi
					học và ghi chú cho mục tiêu để có thể hoàn thành báo cáo của
					buổi học can thiệp cá nhân.
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								w-56
								uppercase
								text-neutral-400 text-xs
								font-semibold
							"
						>
							Nhận xét buổi học
						</div>
						<SwitchButton v-model:value="require_report_note" />
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div
							class="
								input-group__label
								w-56
								uppercase
								text-neutral-400 text-xs
								font-semibold
							"
						>
							Ghi chú cho mục tiêu
						</div>
						<SwitchButton v-model:value="require_goal_note" />
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				mt-10
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
			"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">
					Tự động hoàn thành báo cáo tháng
				</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					Ở chế độ bật, cơ sở can thiệp có thể tự động hoàn thành báo
					cáo tháng
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								w-56
								uppercase
								text-neutral-400 text-xs
								font-semibold
							"
						>
							Bật chế độ Tự động
						</div>
						<SwitchButton
							v-model:value="enable_auto_fill_assessment_report"
						/>
					</div>
				</div>
			</div>
			<div
				class="__section__header font-semibold p-6 border-b"
				v-if="enable_auto_fill_assessment_report"
			>
				<div class="text-neutral-600">Mục tiêu có kết quả</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="
							input-group__label
							w-1/3
							uppercase
							text-neutral-400 text-xs
							font-semibold
						"
					>
						Kết quả lớn hơn {{ autoFillData?.end_percent }}%
					</div>
					<div class="goal-class">Mục tiêu hoàn thành</div>
				</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="
							input-group__label
							w-1/3
							uppercase
							text-neutral-400 text-xs
							font-semibold
						"
					>
						Kết quả đạt {{ autoFillData?.start_percent }}% -
						{{ autoFillData?.end_percent }}%
					</div>
					<div class="goal-class">Mục tiêu lặp lại vào tháng tới</div>
				</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="
							input-group__label
							w-1/3
							uppercase
							text-neutral-400 text-xs
							font-semibold
						"
					>
						Kết quả nhỏ hơn {{ autoFillData?.start_percent }}%
					</div>
					<div class="goal-class">Mục tiêu tạm dừng</div>
				</div>
				<div class="text-neutral-600">Mục tiêu chưa được dạy</div>
				<div class="flex items-center p-6 w-full">
					<div
						class="
							input-group__label
							w-1/3
							uppercase
							text-neutral-400 text-xs
							font-semibold
						"
					>
						mặc định
					</div>
					<div
						class="goal-class"
						v-if="
							autoFillData?.next_plan_for_unlearned_goal ===
							'continued'
						"
					>
						Lặp lại mục tiêu
					</div>
					<div
						class="goal-class"
						v-if="
							autoFillData?.next_plan_for_unlearned_goal ===
							'stopped'
						"
					>
						Tạm dừng mục tiêu
					</div>
				</div>
				<div class="py-6 flex justify-end">
					<button
						type="button"
						class="button-p text-center whitespace-nowrap w-max"
						@click="sideOverShow = true"
					>
						Chỉnh sửa
					</button>
				</div>
			</div>
		</div>
		<div
			class="
				mt-10
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
			"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">Gửi báo cáo</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					CSCT có thể lựa chọn các báo cáo được tự động gửi đến app
					Phụ huynh
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div>
							<div
								class="
									input-group__label
									w-56
									uppercase
									text-neutral-400 text-xs
									font-semibold
								"
							>
								Báo cáo can thiệp cá nhân
							</div>
							<div
								class="
									font-normal
									text-neutral-500
									leading-5
									text-xs
									mt-2
								"
							>
								{{
									enable_lesson_report_sent
										? `Ở chế độ bật, các báo cáo cá nhân sẽ được tự động gửi đến phụ huynh sau khi hoàn thành.`
										: `Ở chế độ tắt, chỉ có giám đốc, quản lý cơ sở, trưởng chuyên môn và trị liệu viên thực hiện báo cáo mới có thể chọn gửi đến cho phụ huynh.`
								}}
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_lesson_report_sent"
						/>
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div>
							<div
								class="
									input-group__label
									w-56
									uppercase
									text-neutral-400 text-xs
									font-semibold
								"
							>
								Báo cáo bán trú
							</div>
							<div
								class="
									font-normal
									text-neutral-500
									leading-5
									text-xs
									mt-2
								"
							>
								{{
									enable_day_care_report_sent
										? `Ở chế độ bật, các báo cáo bán trú sẽ được tự động gửi đến phụ huynh sau khi hoàn thành.`
										: `Ở chế độ tắt, chỉ có giám đốc, quản lý cơ sở, trưởng chuyên môn và trị liệu viên thực hiện báo cáo mới có thể chọn gửi đến cho phụ huynh.`
								}}
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_day_care_report_sent"
						/>
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div>
							<div
								class="
									input-group__label
									w-56
									uppercase
									text-neutral-400 text-xs
									font-semibold
								"
							>
								Báo cáo tuần
							</div>
							<div
								class="
									font-normal
									text-neutral-500
									leading-5
									text-xs
									mt-2
								"
							>
								{{
									enable_weekly_report_sent
										? `Ở chế độ bật, các báo cáo bán trú sẽ được tự động gửi đến phụ huynh.`
										: `Ở chế độ tắt, chỉ có giám đốc, quản lý cơ sở, trưởng chuyên môn và trị liệu viên thực hiện báo cáo mới có thể chọn gửi đến cho phụ huynh.`
								}}
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_weekly_report_sent"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				mt-10
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
			"
		>
			<div class="__section__header font-semibold p-6 border-b">
				<div class="text-neutral-600">Hiển thị thống kê Chuyên cần</div>
				<div
					class="font-normal text-neutral-500 leading-5 text-sm mt-2"
				>
					Ở chế độ bật, phụ huynh sẽ xem được số buổi học của trẻ
					trong các báo cáo dưới đây
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div>
							<div
								class="
									input-group__label
									w-56
									uppercase
									text-neutral-400 text-xs
									font-semibold
								"
							>
								Báo cáo tuần
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_session_count_for_weekly_report
							"
						/>
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div>
							<div
								class="
									input-group__label
									w-56
									uppercase
									text-neutral-400 text-xs
									font-semibold
								"
							>
								Báo cáo tháng
							</div>
						</div>
						<SwitchButton
							v-model:value="
								enable_session_count_for_monthly_report
							"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="false"
			class="
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
				mt-10
			"
		>
			<div
				class="
					__section__header
					font-semibold
					text-neutral-600
					p-6
					border-b
				"
			>
				Báo cáo ngày
				<div class="max-w-lg font-normal leading-5 text-sm mt-2">
					Ở chế độ bật, CSCT bắt buộc phải điền những thông tin đã bật
					khi tạo mục tiêu mới
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								text-neutral-500
								font-normal
							"
						>
							Bắt buộc điền hoạt động cho từng mục tiêu
						</div>
						<SwitchButton v-model:value="dateValue" />
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div
							class="
								input-group__label
								text-neutral-500
								font-normal
							"
						>
							Bặt buộc điền ghi chú cho từng mục tiêu
						</div>
						<SwitchButton v-model:value="dateValue" />
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="false"
			class="
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
				mt-10
			"
		>
			<div
				class="
					__section__header
					font-semibold
					text-neutral-600
					p-6
					border-b
				"
			>
				Báo cáo kế hoạch
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div>
							<div
								class="
									input-group__label
									w-56
									uppercase
									text-neutral-400 text-xs
									font-semibold
								"
							>
								Tùy chỉnh theo chu kỳ
							</div>
							<div
								class="
									font-normal
									text-neutral-500
									leading-5
									text-xs
									mt-2
								"
							>
								Tắt để giữ chu kỳ mặc định là mỗi tháng một báo
								cáo kế hoạch. Bật để tùy chỉnh chu kỳ của một
								báo cáo kế hoạch.
							</div>
						</div>
						<SwitchButton
							v-model:value="enable_day_care_report_sent"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';
import { Prop, Watch } from 'vue-property-decorator';
import PercentSlideOver from './PercentSlideOver.vue';
import { $api } from '@/services';

@Options({
	name: 'Report',
	components: { SwitchButton, PercentSlideOver },
})
export default class Report extends Vue {
	//----------------------- 🤍 Props 🤍 -----------------------//
	@Prop() org;

	//----------------------- 🤍 Data 🤍 -----------------------//
	enable_half_year_report = true;
	enable_monthly_report = true;
	enable_quarterly_report = false;
	enable_weekly_report = false;
	enable_day_care_report_sent = false;
	enable_lesson_report_sent = false;
	enable_weekly_report_sent = false;
	require_goal_note = false;
	require_report_note = false;
	enable_auto_fill_assessment_report = false;
	onChange = false;
	onWatchOrg = true;
	dateValue = false;
	sideOverShow = false;
	enable_session_count_for_monthly_report = false;
	enable_session_count_for_weekly_report = false;
	autoFillData = null;

	mounted() {
		this.getAutoFill();
	}

	async getAutoFill() {
		try {
			const {
				data: { data },
			} = await $api.org.getAutoFill();
			this.autoFillData = data;
		} catch (e) {
			console.log(e);
		}
	}

	submit() {
		this.getAutoFill();
		this.sideOverShow = false;
	}

	//----------------------- 🤍 Watch 🤍 -----------------------//

	@Watch('org', { deep: true, immediate: true })
	onOrgChange(org) {
		if (org && this.onWatchOrg) {
			this.enable_half_year_report = org?.enable_half_year_report;
			this.enable_monthly_report = org?.enable_monthly_report;
			this.enable_quarterly_report = org?.enable_quarterly_report;
			this.enable_weekly_report = org?.enable_weekly_report;
			this.enable_day_care_report_sent = org?.enable_day_care_report_sent;
			this.enable_session_count_for_monthly_report =
				org?.enable_session_count_for_monthly_report;
			this.enable_session_count_for_weekly_report =
				org?.enable_session_count_for_weekly_report;
			this.enable_lesson_report_sent = org?.enable_lesson_report_sent;
			this.enable_weekly_report_sent = org?.enable_weekly_report_sent;
			this.require_goal_note = org?.require_goal_note;
			this.require_report_note = org?.require_report_note;
			this.enable_auto_fill_assessment_report =
				org?.enable_auto_fill_assessment_report;
			setTimeout(() => {
				this.onChange = true;
			}, 1000);
			this.onWatchOrg = false;
		}
	}

	@Watch('require_goal_note')
	onRequestGoalNote(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				require_goal_note: value,
			});
		}
	}

	@Watch('require_report_note')
	onRequestGoalReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				require_report_note: value,
			});
		}
	}

	@Watch('enable_auto_fill_assessment_report')
	onRequestGoalReportAuto(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_auto_fill_assessment_report: value,
			});
		}
	}

	@Watch('enable_half_year_report')
	onHaftYearReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_half_year_report: value,
			});
		}
	}

	@Watch('enable_quarterly_report')
	onQuarterlyReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_quarterly_report: value,
			});
		}
	}

	@Watch('enable_weekly_report')
	onWeeklyReport(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_weekly_report: value,
			});
		}
	}

	@Watch('enable_day_care_report_sent')
	onEnable_day_care_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_day_care_report_sent: value,
			});
		}
	}

	@Watch('enable_session_count_for_monthly_report')
	onEnable_session_count_for_monthly_report(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_session_count_for_monthly_report: value,
			});
		}
	}

	@Watch('enable_session_count_for_weekly_report')
	onEnable_session_count_for_weekly_report(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_session_count_for_weekly_report: value,
			});
		}
	}

	@Watch('enable_lesson_report_sent')
	onEnable_lesson_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_lesson_report_sent: value,
			});
		}
	}

	@Watch('enable_weekly_report_sent')
	onEnable_weekly_report_sent(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_weekly_report_sent: value,
			});
		}
	}
}
</script>
<style scoped>
.goal-class {
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #1d283a;
}
</style>
